export default "__VITE_ASSET__9x9iwIIt__"